---
nb:
  overview_map:
    homepage: Hjemmeside
    nearest: nærmeste kraftverk
    news: Nyheter
    nve_concession: NVE-konsesjonssak
